import { render, staticRenderFns } from "./pcConcMatProtocolDtl.vue?vue&type=template&id=28ccd9ee&scoped=true&slot=groupTitle&"
import script from "./pcConcMatProtocolDtl.vue?vue&type=script&lang=js&"
export * from "./pcConcMatProtocolDtl.vue?vue&type=script&lang=js&"
import style0 from "./pcConcMatProtocolDtl.vue?vue&type=style&index=0&id=28ccd9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ccd9ee",
  null
  
)

export default component.exports